module.exports = __webpack_public_path__ + "static/img-small-b489a07b76eec350c4e4e694904b76e5.png";